<template>
  <Dialog ref="dialog" :config="config" :beforeClose="beforeClose" :visible='visible' :cancelDialog="cancelDialog" :confirmDialog='confirmDialog' :isdeling='isdeling'>
    <p class="text">
      退出后无法查看该公司数据， 请确认是否继续退出？
    </p>
  </Dialog>
</template>

<script>
import Dialog from "@/components/Dialog";
export default {
  props: {
    rowData:{
      type: Object,
    },
    type:{
      type: String,
    },
    visible: {
      type: Boolean,
    },
    isdeling: {
      type: Boolean,
    },
    cancelDialog:{
      type: Function,
      default: () => {},
    },
    confirmDialog:{
      type: Function,
      default: () => {},
    }
  },
  components: {
    Dialog,
  },
  data() {
    return {
      config: {
        top: '20vh',
        width: '21rem',
        title: '退出用户',
        center: true,
        btnTxt: ['退出','取消'],
      },
    };
  },
  methods: {
    beforeClose(){
      console.log('关闭前');
    },
  }
};
</script>

<style lang="less" scoped>
.title{
  color: #FF0000;
  font-size: 16px;
}
.text{
  color: #333333;
  font-size: 14px;
  margin: 6px 0;
}
</style>
